"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { useMemo } from "react";
const useEventSchema = t0 => {
  const $ = _c(7);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const events = t1;
  const pathname = usePathname();
  let t2;
  if ($[2] !== events || $[3] !== pathname) {
    let t3;
    if ($[5] !== pathname) {
      t3 = item => {
        const name = item.eventName || item.serviceName;
        return {
          "@context": "https://schema.org",
          "@type": "EducationEvent",
          name: `${name} - ${item.startDate} to ${item.endDate}`,
          startDate: item.startDate,
          endDate: item.endDate,
          eventStatus: "https://schema.org/EventScheduled",
          location: {
            "@type": "Place",
            name: "Spoclearn",
            address: {
              "@type": "PostalAddress",
              streetAddress: "3500 S Dupont Hwy Suite DK 101, Dover, DE 19901, United States",
              addressLocality: "Dover",
              postalCode: "19901",
              addressRegion: "PA",
              addressCountry: "US"
            }
          },
          image: [process.env.NEXT_PUBLIC_APP_URL + "/images/logo.svg"],
          description: item.eventDescription || item.serviceEventTitle,
          offers: {
            "@type": "AggregateOffer",
            lowPrice: item.eventDetail.price,
            highPrice: item.eventDetail.price,
            url: process.env.NEXT_PUBLIC_APP_URL + pathname,
            availability: "https://schema.org/InStock",
            validFrom: item.startDate,
            price: item.eventDetail.price,
            priceCurrency: item.eventDetail.currency
          },
          performer: {
            "@type": "PerformingGroup",
            name: "Spoclearn"
          },
          organizer: {
            "@type": "Organization",
            name: "Spoclearn",
            url: process.env.NEXT_PUBLIC_APP_URL
          }
        };
      };
      $[5] = pathname;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = events.map(t3);
    $[2] = events;
    $[3] = pathname;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const result = t2;
  const eventSchema = result;
  return eventSchema;
};
export default useEventSchema;